/**
 * Thanh "Mở app" trên web mobile: quyết định hiện/ẩn NGAY LÚC SSR.
 * Trước đây thanh này chỉ render sau khi JS chạy → chèn 53px lên đầu trang, đẩy cả trang xuống
 * → Core Web Vitals báo CLS 0.92 (Poor) cho mobile từ 29/09. Giờ server đọc User-Agent + cookie
 * "đã đóng" nên HTML trả về đã có (hoặc không có) thanh, không còn nhảy layout.
 */
export type AppBannerOs = 'android' | 'ios' | null;

export const APP_BANNER_DISMISS_COOKIE = 'open_app_banner_dismissed';
export const APP_BANNER_DISMISS_DAYS = 7;

export const detectAppBannerOs = (ua: string, maxTouchPoints = 0, platform = ''): AppBannerOs => {
  const u = ua || '';
  const isIOS = /iPhone|iPad|iPod/i.test(u) || (platform === 'MacIntel' && maxTouchPoints > 1);
  const isAndroid = /Android/i.test(u);
  // Safari iOS đã có banner hệ thống (meta apple-itunes-app) → không hiện thêm
  const iosSafari = isIOS && /Safari/i.test(u) && !/CriOS|FxiOS|EdgiOS|FBAN|FBAV|FB_IAB|Instagram|Zalo|Line\//i.test(u);
  if (iosSafari) return null;
  return isAndroid ? 'android' : isIOS ? 'ios' : null;
};

/** Quyết định ở server: UA + cookie đã đóng (do nút X đặt). */
export const appBannerOsFromRequest = (req?: { headers?: Record<string, any> }): AppBannerOs => {
  const ua = String(req?.headers?.['user-agent'] || '');
  const cookie = String(req?.headers?.cookie || '');
  if (new RegExp(`(^|;\\s*)${APP_BANNER_DISMISS_COOKIE}=1`).test(cookie)) return null;
  return detectAppBannerOs(ua);
};
